import {
  SET_TABLE_CHECKED_ITEMS,
  SET_TABLE_FILTERED_DATA,
  TABLE_CLEAR_DATA,
  TABLE_CLICKED_ROW,
  TABLE_SET_ACTIVE_FILTER,
  TABLE_LOAD_DATA,
  TABLE_LOAD_DATA_FAILURE,
  TABLE_LOAD_DATA_SUCCESS,
  TRIGGER_TABLE_RELOAD, TABLE_CUSTOM_FILTER_CLEAR,
} from '../actions/types/ListTableActionTypes';
import { AUTH_LOGOUT } from '../../redux/actions/types/authActionTypes';

const tableInitialState = {
  isLoading: false,
  mainTableId: null,
  data: [],
  selectedRows: [],
  selection: [],
  selectAll: false,
  filteredData: [],
  refresh: false,
};

const tablesInitialState = {
  MRD_MONITORING_REPORT_ALL_MRDS: tableInitialState,
  MRD_MONITORING_REPORT_ALL_ISSUES: tableInitialState,
  MRD_MONITORING_REPORT_REPORTED_BY_USER: tableInitialState,
  MRD_MONITORING_REPORT_XML_DELAYED: tableInitialState,
  MRD_MONITORING_REPORT_NO_SYNC: tableInitialState,
  MRD_DENEST_IMPC_MAPPING: tableInitialState,
  MRD: tableInitialState,
  MRD_INACTIVE: tableInitialState,
  MRD_ADMINISTRATION_IATA: tableInitialState,
  MRD_ADMINISTRATION_FLIGHTS: tableInitialState,
  MRD_DEVICE_LIST_BY_COUNTRY: tableInitialState,
  MRD_IMPC_LIST_BY_COUNTRY: tableInitialState,
  HANDLERS_BY_MRD_DEVICE: tableInitialState,
  HANDLERS_BY_IMPC: tableInitialState,
  MRD_SETTINGS: tableInitialState,
  MRD_CONTACTS_PAGE: tableInitialState,
  MRD_APP_TRANSLATIONS: tableInitialState,
  IPC_CONTACTS: tableInitialState,
  MRD_CONTACTS: tableInitialState,
  XML_CONTACTS: tableInitialState,
  MRD_CONTACTS_WIZARD: tableInitialState,
  ALL_CONTACTS: tableInitialState,
  NOTIFICATION_SERVICE_THRESHOLD: tableInitialState,
  DATA_SHARING_VIEW: tableInitialState,
  activeFilter: new Map(),
};

export default (state = tablesInitialState, action) => {
  switch (action.type) {
  case TABLE_LOAD_DATA: {
    const { tableDefinition } = action.payload;
    return {
      ...state,
      [tableDefinition.id]: {
        ...tableInitialState,
        ...state[tableDefinition.id],
        selectedRows: [],
        selection: [],
        selectAll: false,
        isLoading: true,
        refresh: false,
      },
    };
  }
  case TABLE_LOAD_DATA_SUCCESS: {
    const {
      tableDefinition,
      mainTableId,
      data,
    } = action.payload;

    return {
      ...state,
      [tableDefinition.id]: {
        ...tableInitialState,
        ...state[tableDefinition.id],
        mainTableId,
        isLoading: false,
        data: tableDefinition.dataTransformer(data),
      },
    };
  }
  case TABLE_LOAD_DATA_FAILURE:
    return {
      ...state,
      [action.payload.tableDefinition.id]: {
        ...tableInitialState,
        mainTableId: action.payload.mainTableId,
        isLoading: false,
        error: action.payload.error,
      },
    };
  case TABLE_CLEAR_DATA:
    return action.payload.tableDefinition && action.payload.tableDefinition.id ? {
      ...state,
      [action.payload.tableDefinition.id]: {
        ...tableInitialState,
        isLoading: true,
      },
    } : tablesInitialState;
  case SET_TABLE_CHECKED_ITEMS: {
    const {
      listId,
      checkboxSelections,
    } = action.payload;
    return {
      ...state,
      [listId]: {
        ...tableInitialState,
        ...state[listId],
        checkboxSelections,
      },
    };
  }
  case SET_TABLE_FILTERED_DATA: {
    const {
      listId,
      visibleData,
    } = action.payload;
    return {
      ...state,
      [listId.id]: {
        ...tableInitialState,
        ...state[listId.id],
        filteredData: visibleData,
      },
    };
  }
  case TABLE_CLICKED_ROW:
    return {
      ...state,
      clickedRow: { ...action.clickedRow },
    };
  case TRIGGER_TABLE_RELOAD: {
    const { tableDefinition } = action.payload;
    return {
      ...state,
      [tableDefinition.id]: {
        ...tableInitialState,
        ...state[tableDefinition.id],
        refresh: true,
      },
    };
  }
  case TABLE_SET_ACTIVE_FILTER: {
    const {
      listId,
      filtered,
    } = action.payload;
    return {
      ...state,
      activeFilter: listId === undefined ? new Map() : state.activeFilter.set(listId, filtered),
    };
  }
  case TABLE_CUSTOM_FILTER_CLEAR:
    return {
      ...state,
      [action.payload.listId]: {
        ...tableInitialState,
        ...state[action.payload.listId],
        filteredData: [],
      },
      activeFilter: new Map(),
    };
  case AUTH_LOGOUT:
    return tablesInitialState;
  default:
    return state;
  }
};
